<cosmos-section
  sectionTitle="Collaborators"
  class="cosmos-cluster-details-modal__section"
>
  <cosmos-table
    [columns]="_columns"
    [dataSource]="_dataSource"
    [isFilterable]="false"
    [isPaginable]="false"
    (clickedRow)="openUserDetails($event)"
  ></cosmos-table>
  <button
    addButton
    (click)="openAddCollaboratorDialog()"
    class="cosmos-cluster-details-modal__button"
  >
    Add collaborator
  </button>
</cosmos-section>

<ng-template #actions let-data="row">
  <button
    *ngIf="!data.isOwner"
    (click)="removeCollaborator(data)"
    class="cosmos-cluster-collaborators__button"
  >
    Remove
  </button>
</ng-template>
